import React from 'react'
import ReactPlayer from 'react-player'
import style from '../Styles/style.module.css'
const Trailer = ({ setShowTrailer, imageTrailerUrl }) => {

  //closing the trailer on clicking the close button 
  const trailerClose = () => {
    setShowTrailer(false);
  }

  return (
    <>
      {/* blurring the background when trailer is shown */}
      <div onClick={() => { setShowTrailer(false) }} className={style.bodyMask} ></div>

      {/* creating the trailer box  */}
      <div className={style.videoPlayer}>

        {/* showing the trailer */}
        <div className={style.trailerPlayer}>
          <ReactPlayer style={{ background: "black" }} url={`${imageTrailerUrl}`} height="100%" width="100%" controls playing loop light />
        </div>


        {/* creating the close button */}
        <button className={style.closeBtn} onClick={() => { trailerClose() }}>Close</button>
      </div>

    </>
  )
}

export default Trailer
